import React from 'react'
import {Footer, Navbar, Product } from '../components'

function Products() {
  return (
    <>
      <Navbar />
      <Product />
      <Footer  />
    </>
  )
}

export default Products
